<template>
  <div class="activity_detail content">
    <div class="render_html" v-html='activity.about'></div>
  </div>
</template>

<script>
export default {
  name: 'activity-detail',
  props: ['activity'],
  components: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "@/assets/css/mixin.scss";
  @import "@/assets/css/render-html.scss";
  .activity_detail {
    color: #000;
    padding-top: rem(20);
    padding-bottom: rem(20);
  }
</style>
